import React from 'react';
import Menu from './components/Menu';
import { plansPricingMenu } from '../../config/linkInfo.js';

export const PlansAndPricingMenu = () => {
  return <Menu {...plansPricingMenu()} />;
};

export default PlansAndPricingMenu;
